import { useCommonComponentContext } from "@maysoft/common-component-react";
import { useEffect, useState } from "react";

import Helpers from "../../../commons/helpers";
import MessageTemplateCaseService from "../../../services/message/MessageTemplateCase.service";
import { IMessageTemplateCase } from "../../../commons/interfaces";
import { MessageTemplateType } from "../../../constants/enums";

export interface IMessageTemplateCaseUseDataProps {
    id: string;
    getAllMessageTemplate: (type: MessageTemplateType) => Promise<void>;
    getAllCaseCode: (type: MessageTemplateType) => Promise<void>;
    initialData?: {
        tenantCode?: string;
        serviceCode?: string;
    }
}

export type IMessageTemplateCaseErrors = { [k in keyof IMessageTemplateCase]?: string };

const useData = ({ initialData, id, getAllMessageTemplate, getAllCaseCode }: IMessageTemplateCaseUseDataProps) => {
    const { userInfo, tenantCode, serviceCode, onError, onHideLoading, onShowLoading } = useCommonComponentContext();
    const organizationId = userInfo.userProfile?.organizationId || "0";

    const [data, setData] = useState<IMessageTemplateCase>({
        templateType: MessageTemplateType.Email,
        templateCode: "",

        tenantCode: initialData?.tenantCode ?? tenantCode,
        serviceCode: initialData?.serviceCode ?? serviceCode,
        organizationId: userInfo?.userProfile?.organizationId || "0",
    } as IMessageTemplateCase);
    const [error, setError] = useState<IMessageTemplateCaseErrors>({} as IMessageTemplateCaseErrors);

    const [isEdited, setIsEdited] = useState<boolean>(false);

    useEffect(() => {
        getDetail(id);
    }, [id, organizationId]);

    const getDetail = async (id?: string) => {
        try {
            onShowLoading();
            if (!Helpers.isNullOrEmpty(id)) {
                const result = await MessageTemplateCaseService.getDetail(id);

                await getAllMessageTemplate(result?.templateType);
                await getAllCaseCode(Number(result?.templateType));
                setData(result);
            } else {
                await getAllMessageTemplate(MessageTemplateType.Email);
                await getAllCaseCode(MessageTemplateType.Email);
            }
        } catch (error) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        } finally {
            onHideLoading();
        }
    };

    const onChangeValue = async (value: any, key: keyof IMessageTemplateCase) => {
        if (key === "templateType") {
            onShowLoading();
            await getAllMessageTemplate(value);
            await getAllCaseCode(Number(value));

            setData((prev) => ({ ...prev, [key]: value, templateCode: undefined, caseCode: undefined }));
            setError((prev) => ({ ...prev, templateCode: "", caseCode: "" }));
            onHideLoading();
        } else {
            setData((prev) => ({ ...prev, [key]: value }));
        }

        if (!Helpers.isNullOrEmpty(error[key])) {
            setError((prev) => ({ ...prev, [key]: "" }));
        }
        setIsEdited(true);
    };

    return {
        data,
        error,
        isEdited,
        setIsEdited,
        getDetail,
        setError,
        onChangeValue,
        organizationId,
    };
};

export default useData;
